<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/BmUakr/images/cover.jpg?1698233336076" alt="This image is the cover for the book Parenting for Peace"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Parenting for Peace
      </h1>
      <p class="bookDescription body article font2">
        <p>If we really want to change the world, let's raise a generation hardwired for peace and innovation. Marcy Axness details a unique seven-step, seven-principle matrix for helping children achieve self-regulation, self-reflection, trust, and empathy. These qualities are the result of dynamic interactions between genetics and environment, beginning before the child is even born: foundations for this level of health begin forming during the prenatal period, and some aspects of optimal development are influenced as early as conception.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Marcy Axness
      </h2>
      
      <p class="authorDescription body article">Marcy Axness has won multiple awards and an Emmy nomination as a documentary writer/producer, covering emerging topics in health for CBS News, and has produced programming for Lifetime, Showtime, and The Disney Channel. As a result, she is sound-bite savvy, media-wise, and tapped into popular culture in a way that helps her connect with readers and listeners.  Her own life and discoveries as an adopted person and a mother led her to pursue a deeper understanding of how we become who we become, how early that begins, and how we can do it in a healthier, more joyful way. She teaches prenatal development at Santa Barbara Graduate Institute; is a popular international speaker on attachment, culture, and child and parent development; and has been featured in several documentary films as an expert in adoption, prenatal development and Waldorf education. She counsels parents and pre-parents in her private Quantum Parenting practice, applying, honing, and documenting the successful results of Parenting for Peace principles in real life. With her husband of 25 years, she has raised a son, 23, and a daughter, 20, both of whom are engaging, thoughtful, flourishing young adults.  Marcy has a solid constituency and devoted following, built up over nearly twenty years of speaking, writing, counseling, and networking within multiple intersecting communities whose interests center on progressive human insights, development, and evolution. Her combination of life experience, cultural acumen, and scholarly credibility uniquely equip her to chart this compelling, entertaining, and engaging human roadmap through attachment theory, developmental neurobiology, epigenetics, cell biology, prenatal psychology, child development, and consciousness research to illuminate a pathway of healing and wholeness for coming generations.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Sentient Publications
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?619061be